/* ── DEEPLY LIFE — THEME JS ── */

(function () {
  'use strict';

  // ── PROGRESSIVE ENHANCEMENT ──────────────────────────────
  // Add dl-js immediately (synchronously) so the CSS reveal
  // classes activate before DOMContentLoaded — this prevents
  // a flash of visible content before the observer kicks in.
  var settings = window.DL_SETTINGS || {};
  if (settings.enableScrollReveal !== false) {
    document.documentElement.classList.add('dl-js');
  }

  // Everything else waits for the DOM to be fully parsed
  document.addEventListener('DOMContentLoaded', function () {

    // ── NAV SCROLL ─────────────────────────────────────────
    var nav = document.getElementById('dl-nav');
    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('is-scrolled', window.scrollY > 60);
      }, { passive: true });
    }

    // ── SCROLL REVEAL ───────────────────────────────────────
    if (settings.enableScrollReveal !== false && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            revealObserver.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.reveal').forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      // Fallback: make everything visible if no observer support
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    // ── TESTIMONIALS CAROUSEL ───────────────────────────────
    var track = document.getElementById('dl-t-track');
    var dotsContainer = document.getElementById('dl-t-dots');
    var prevBtn = document.getElementById('dl-t-prev');
    var nextBtn = document.getElementById('dl-t-next');

    if (track && dotsContainer && track.children.length > 0) {
      var currentPage = 0;

      function getPageSize() {
        if (window.innerWidth <= 768) return 1;
        if (window.innerWidth <= 1024) return 2;
        return 3;
      }

      function buildDots() {
        var ps = getPageSize();
        var pages = Math.ceil(track.children.length / ps);
        dotsContainer.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var btn = document.createElement('button');
          btn.className = 'dl-t-dot' + (i === currentPage ? ' is-active' : '');
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Page ' + (i + 1));
          btn.dataset.i = i;
          btn.addEventListener('click', (function (idx) {
            return function () { goToPage(idx); };
          })(i));
          dotsContainer.appendChild(btn);
        }
      }

      function goToPage(page) {
        var ps = getPageSize();
        var pages = Math.ceil(track.children.length / ps);
        currentPage = Math.max(0, Math.min(page, pages - 1));

        // Use getBoundingClientRect for accurate post-layout width
        var cardRect = track.children[0].getBoundingClientRect();
        var cardWidth = cardRect.width;

        // Get gap from computed style
        var computedGap = parseFloat(window.getComputedStyle(track).gap);
        var gap = isNaN(computedGap) ? 32 : computedGap;

        var offset = currentPage * ps * (cardWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        document.querySelectorAll('.dl-t-dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === currentPage);
        });
      }

      // Use rAF to ensure layout is complete before first measurement
      requestAnimationFrame(function () {
        buildDots();
        goToPage(0);
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });

      // Touch swipe
      var touchStartX = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 50) goToPage(dx < 0 ? currentPage + 1 : currentPage - 1);
      });

      // Rebuild on resize
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          currentPage = 0;
          buildDots();
          requestAnimationFrame(function () { goToPage(0); });
        }, 150);
      });
    }

    // ── KLAVIYO FORM ────────────────────────────────────────
    var formFields = document.querySelector('.dl-form__fields');
    var submitBtn = document.getElementById('dl-form-submit');
    var statusEl = document.getElementById('dl-form-status');

    if (formFields && submitBtn) {
      var companyId = formFields.dataset.klaviyoCompanyId;
      var listId = formFields.dataset.klaviyoListId;

      submitBtn.addEventListener('click', async function () {
        var email = (document.getElementById('dl-email') || {}).value;
        var consent = (document.getElementById('dl-consent') || {}).checked;
        var firstName = (document.getElementById('dl-first-name') || {}).value;
        var lastName = (document.getElementById('dl-last-name') || {}).value;
        var sourceEl = document.getElementById('dl-source');
        var source = sourceEl ? sourceEl.value : '';

        email = email ? email.trim() : '';
        firstName = firstName ? firstName.trim() : '';
        lastName = lastName ? lastName.trim() : '';

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showStatus('Please enter a valid email address.', 'error');
          return;
        }
        if (!consent) {
          showStatus('Please agree to the privacy policy to continue.', 'error');
          return;
        }
        if (!companyId || !listId) {
          showStatus('Form configuration missing — please add your Klaviyo API key in Theme Settings.', 'error');
          return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
        showStatus('', '');

        try {
          var payload = {
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: Object.assign(
                      { email: email },
                      firstName ? { first_name: firstName } : {},
                      lastName  ? { last_name: lastName }  : {},
                      {
                        properties: Object.assign(
                          { signup_source: 'Deeply Life Waitlist' },
                          source ? { referral_source: source } : {}
                        )
                      }
                    )
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: listId } }
              }
            }
          };

          var res = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2023-10-15' },
              body: JSON.stringify(payload)
            }
          );

          if (res.ok || res.status === 202) {
            showStatus("You're on the list. We'll be in touch.", 'success');
            submitBtn.textContent = "You're In ✓";
            ['dl-first-name', 'dl-last-name', 'dl-email'].forEach(function (id) {
              var el = document.getElementById(id);
              if (el) el.value = '';
            });
            if (sourceEl) sourceEl.selectedIndex = 0;
            var consentEl = document.getElementById('dl-consent');
            if (consentEl) consentEl.checked = false;
          } else {
            var err = await res.json().catch(function () { return {}; });
            var msg = (err.errors && err.errors[0] && err.errors[0].detail)
              || 'Something went wrong. Please try again.';
            showStatus(msg, 'error');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Notify Me at Launch';
          }
        } catch (e) {
          showStatus('Network error. Please check your connection and try again.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify Me at Launch';
        }
      });
    }

    function showStatus(msg, type) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'dl-form__status' + (type ? ' is-' + type : '');
    }

  }); // end DOMContentLoaded

})();
